// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1f3n8","notes":"Notes_notes__2KbSF"};